export default {
  id: 'what-is-act',
  title: 'What is ACT?',
  content: `## What is ACT?

ACT stands for **Adaptive Conviction Training**. It is TradeLab's core daily practice drill for building high-quality trade decision skills.

> ACT is not paper trading. It is deliberate decision practice — like a flight simulator for traders.

---

## The Core Problem ACT Solves

Most traders lose money not because they lack knowledge, but because they cannot execute consistently under pressure. They know what a good setup looks like. But when real money is involved — or even virtual money in a live simulation — emotions override the process.

ACT separates the decision from the outcome. You analyse a real historical setup, make your decision, plan your trade, and then see what actually happened. Over hundreds of repetitions, this builds reliable decision-making instincts.

---

## How It Works

Every day at **midnight IST**, a fresh set of scenarios is generated:
- **10 Swing scenarios** — based on NSE daily candles
- **10 Intraday scenarios** — based on NSE 1-minute candles

The same scenarios are shown to all users that day. Each one is a real historical setup from a real stock on a real past date — with the outcome hidden until after you decide.

You choose: **Enter**, **Wait**, or **Skip**.

Then you submit your trade plan — entry price, stop loss, target, quantity, and your reasoning.

Then the outcome is revealed.

---

## Why ACT Is Different from Live Trading

| ACT | Live Paper Trading |
|---|---|
| Historical setup — outcome is fixed | Real-time — outcome is unknown |
| Decision must be made before seeing outcome | Can change mind as price moves |
| Scored on quality of decision | Scored only on P&L |
| Removes emotional noise of watching a position | Emotional noise is present |
| 20 scenarios per day — rapid skill building | Limited by real market opportunities |

---

## Who Should Use ACT

- Beginners: to learn what good setups look like and how to build a trade plan
- Intermediate traders: to identify and fix specific decision biases (FOMO, revenge trading, etc.)
- Advanced traders: to maintain and benchmark decision quality as a daily habit

---

## Where to Find ACT

**Profile → ACT Practice** or via the Learning Module`,
};
